import React from 'react'
import styles from '../TitleBar/TitleBar.module.css'
import { PortableText } from "@portabletext/react";
const ptComponents = {
  marks: {
    purple: ({ children }) => (
      <span style={{ color: "#6524EB" }}>{children}</span>
    ),
    strong: ({ children }) => <strong>{children}</strong>,
    break: ({ children }) => (
      <>
        {children}
        <br />
      </>
    ),
  },
  list: {
    bullet: ({ children }) => <ul className="list-disc ml-6">{children}</ul>,
    number: ({ children }) => (
      <ol className="list-decimal ml-6">{children}</ol>
    ),
  },
};


const TitleBar = ({ marginBlock, blocks }) => {
  return (
    <div>
      <div className={styles.TopSection} style={{ marginBlock: marginBlock }}>
        <div className={styles.LeftBar}>
          <h5 className={styles.subTitle}>
            <PortableText value={blocks} components={ptComponents} />
          </h5>
        </div>
      </div>
    </div>
  )
}

export default TitleBar;
